var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineDocumentUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3V2.375C4.65482 2.375 4.375 2.65482 4.375 3H5ZM19 21V21.625C19.3452 21.625 19.625 21.3452 19.625 21H19ZM5 21H4.375C4.375 21.3452 4.65482 21.625 5 21.625V21ZM14 3L14.4419 2.55806C14.3247 2.44085 14.1658 2.375 14 2.375V3ZM19 8H19.625C19.625 7.83424 19.5592 7.67527 19.4419 7.55806L19 8ZM19 20.375H5V21.625H19V20.375ZM5.625 21V3H4.375V21H5.625ZM5 3.625H14V2.375H5V3.625ZM18.375 8V21H19.625V8H18.375ZM13.5581 3.44194L18.5581 8.44194L19.4419 7.55806L14.4419 2.55806L13.5581 3.44194ZM12.375 3V7H13.625V3H12.375ZM15 9.625H19V8.375H15V9.625ZM12.375 7C12.375 8.44975 13.5503 9.625 15 9.625V8.375C14.2406 8.375 13.625 7.75939 13.625 7H12.375Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V18M12 12L14.5 14.5M12 12L9.5 14.5",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineDocumentUpload);
export default __webpack_public_path__ + "static/media/outline-document-upload.6a231e6b.svg";
export { ForwardRef as ReactComponent };